import { writable } from 'svelte/store';
export var context = writable({});